export const getCompetitionName = (row) => {
  const c = row?.competition;
  if (typeof c === 'string') return c;
  if (c != null && typeof c === 'object') return c?.name ?? c?.title ?? null;
  return row?.competition__name ?? row?.competition_name ?? null;
};

export const getRoundName = (row) => {
  const val = row?.round_name ?? row?.round ?? row?.matchday ?? row?.match_round ?? null;
  if (val != null && typeof val === 'object') return val?.name ?? val?.title ?? null;
  return val;
};

export const getCompetitionRoundLabel = (row) => {
  const comp = getCompetitionName(row);
  const round = getRoundName(row);
  if (!comp && !round) return null;
  if (comp && round) return `${comp} - ${round}`;
  return comp || round;
};

export const sortMatchesByDateDesc = (matches = []) =>
  [...matches].sort((a, b) => new Date(b.date) - new Date(a.date));

export const groupMatchesByCompetitionRound = (matches = []) => {
  const sorted = sortMatchesByDateDesc(matches);
  let lastLabel = null;
  return sorted.map((match) => {
    const label = getCompetitionRoundLabel(match);
    const showSubheader = label && label !== lastLabel;
    lastLabel = label;
    return { match, label, showSubheader };
  });
};
